import * as routes from '@/constants/adminPanelRoutes';
import checkAdminPanelAuth from '@/router/middleware/checkAdminPanelAuth';
import checkAdminPanelNonAuth from '@/router/middleware/checkAdminPanelNonAuth';

export default [
  {
    path: '/admin-panel',
    component: () => import('@/layouts/AdminPanel.vue'),
    children: [
      {
        path: 'login',
        name: routes.ADMIN_PANEL_LOGIN,
        component: () => import('@/views/AdminPanel/Auth/index.vue'),
        meta: {
          isAuthPage: true,
          middleware: [checkAdminPanelNonAuth],
        },
      },
      {
        path: 'password/reset',
        name: routes.ADMIN_PANEL_RESET_PASSWORD,
        component: () => import('@/views/AdminPanel/Auth/index.vue'),
        meta: {
          isAuthPage: true,
          middleware: [checkAdminPanelNonAuth],
        },
      },
      {
        path: '',
        name: routes.ADMIN_PANEL,
        component: () => import('@/views/AdminPanel/index.vue'),
        meta: {
          middleware: [checkAdminPanelAuth],
        },
      },
      {
        path: 'employees',
        name: routes.ADMIN_PANEL_EMPLOYEES,
        component: () => import('@/views/AdminPanel/Employees/index.vue'),
        meta: {
          middleware: [checkAdminPanelAuth],
        },
      },
      {
        path: 'employees/:id',
        name: routes.ADMIN_PANEL_EMPLOYEE,
        component: () => import('@/views/AdminPanel/Employees/Detailed/index.vue'),
        meta: {
          middleware: [checkAdminPanelAuth],
        },
      },
      {
        path: 'clients',
        name: routes.ADMIN_PANEL_CLIENTS,
        component: () => import('@/views/AdminPanel/Clients/index.vue'),
        meta: {
          middleware: [checkAdminPanelAuth],
        },
      },
      {
        path: 'clients/:id',
        name: routes.ADMIN_PANEL_CLIENT,
        component: () => import('@/views/AdminPanel/Clients/Detailed/index.vue'),
        meta: {
          middleware: [checkAdminPanelAuth],
        },
      },
      {
        path: 'profile',
        name: routes.ADMIN_PANEL_PROFILE,
        component: () => import('@/views/AdminPanel/Profile/index.vue'),
        meta: {
          middleware: [checkAdminPanelAuth],
        },
      },
    ],
  },
];
